import * as Yup from 'yup';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';
import { SubmitInvoiceChargeFormFields } from '../types';
import { PaymentMethods } from './components/invoice-template-section/types';

export const PaymentMethodsFormFields = {
    PAYMENT_METHOD: 'paymentMethod',
    BANK_NAME: 'bankName',
    IBAN: 'iban',
    BIC: 'bic',
    URL: 'url',
} as const;

export type PaymentMethodDraft = {
    [PaymentMethodsFormFields.PAYMENT_METHOD]: PaymentMethods | null;
    [PaymentMethodsFormFields.BANK_NAME]?: string | null;
    [PaymentMethodsFormFields.IBAN]?: string | null;
    [PaymentMethodsFormFields.BIC]?: string | null;
    [PaymentMethodsFormFields.URL]?: string | null;
};

export const invoiceChargeSchema: Yup.SchemaOf<SubmitInvoiceChargeFormFields> = Yup.object({
    amount: Yup.number()
        .nullable()
        .required('Amount is required.')
        .min(0, 'Amount must be greater than or equal to 0.'),
    description: Yup.string()
        .transform((value) => value ?? '')
        .required(getRequiredMessage('description')),
    nominalCode: Yup.string()
        .transform((value) => value ?? '')
        .required(getRequiredMessage('nominalCode'))
        .matches(/^\d+$/, 'Nominal code must contain digits only.')
        .max(8, 'Nominal code must be no more than 8 digits.'),
    productCode: Yup.string()
        .transform((value) => value ?? '')
        .required(getRequiredMessage('productCode')),
    taxCode: Yup.string()
        .transform((value) => value ?? '')
        .required(getRequiredMessage('taxCode')),
    percentage: Yup.number()
        .nullable()
        .typeError('Percentage must be a number.')
        .min(0, 'Percentage cannot be less than 0.')
        .optional(),
});
